@if (clickable) {
    <button
        #buttonElement
        type="button"
        class="surface-tier-badge btn badge"
        [ngClass]="tierThemeClasses"
        (click)="popoverComponent.invokePopover()">
        @if (icon) {
            <fa-icon [icon]="icon" [fixedWidth]="true" class="no-margin"/>
        } @else {
            <img [src]="image" [alt]="tier + ' icon'"/>
        }
    </button>

    <fdx-surface-upgrade-popover
        #popoverComponent
        [target]="target"
        [feature]="feature"
        [tier]="tier"
        [currentExport]="currentExport"
        [placement]="popoverPlacement"/>
} @else {
    <span
        class="surface-tier-badge badge"
        [ngClass]="tierThemeClasses">
        @if (icon) {
            <fa-icon [icon]="icon" [fixedWidth]="true"/>
        } @else {
            <img [src]="image" [alt]="tier + ' icon'"/>
        }
    </span>
}
